import { PauseIcon, PlayIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";

import { ShowcaseSong } from "@/types/defs/conversionShowcase";
import { cn } from "@/utils/cn";

export function ConversionShowcaseSongRow({
  song,
  isSelected,
  isSongPlaying,
  onPlay,
  onSelect,
  registerFromRef,
  variant,
}: {
  song: ShowcaseSong;
  isSelected: boolean;
  isSongPlaying: boolean;
  onPlay: () => void;
  onSelect: () => void;
  registerFromRef: (songLabel: string, el: HTMLElement | null) => void;
  variant: "mobile" | "desktop";
}) {
  const isDesktop = variant === "desktop";

  const audioControlIcon =
    isSongPlaying ?
      <PauseIcon
        className={cn("h-3 w-3", isSelected ? "fill-white" : "fill-gray-400")}
      />
    : <PlayIcon
        className={cn(
          "ml-0.5 h-3 w-3",
          isSelected ? "fill-white" : "fill-gray-400"
        )}
      />;

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onPlay}
        aria-label={isSongPlaying ? "Pause" : "Play"}
        className={cn(
          "flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all",
          isSelected ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-400",
          isDesktop && !isSelected && "hover:bg-gray-200"
        )}
      >
        {isDesktop ?
          <motion.div
            className="flex items-center justify-center"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              type: "spring" as const,
              stiffness: 400,
              damping: 28,
            }}
          >
            {audioControlIcon}
          </motion.div>
        : audioControlIcon}
      </button>
      <button
        type="button"
        ref={(el) => {
          registerFromRef(song.label, el);
        }}
        onClick={onSelect}
        className={cn(
          "flex h-9 min-w-0 items-center overflow-hidden rounded-full text-left font-medium transition-all",
          isDesktop ? "flex-1 px-4 text-sm" : "flex-1 px-3 text-[13px]",
          isSelected ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-700",
          isDesktop && !isSelected && "hover:bg-gray-200"
        )}
      >
        {isDesktop ?
          song.label
        : <span className="truncate">{song.label}</span>}
      </button>
    </div>
  );
}
